// extracted by mini-css-extract-plugin
module.exports = {"headerWithSubHeader":"headerWithSubHeader_headerWithSubHeader__iIHHE","header":"headerWithSubHeader_header__73IEP","subHeader":"headerWithSubHeader_subHeader__3FlKf"};